import { commonServiceSlice } from "../common/commanServiceSlice";
import { fetchQuickServices } from "./quickThunk";

const quickSlice = commonServiceSlice({
  name: "quickServices",
  thunk: fetchQuickServices,
});

export default quickSlice.reducer;
